import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send, CheckCircle } from 'lucide-react';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    
    // WhatsApp contact number
    const phoneNumber = '923329754400';
    const message = encodeURIComponent('I am here for free consultation');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        // Simulate API call
        setTimeout(() => {
            setIsSubmitting(false);
            setIsSubmitted(true);
            setFormData({
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
            });
            
            // Reset success message after 5 seconds
            setTimeout(() => {
                setIsSubmitted(false);
            }, 5000);
        }, 1500);
    };

    const handleWhatsappContact = () => {
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div>
            {/* Hero Section */}
            <div className="relative h-[400px] bg-gray-900">
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-900 to-indigo-700 opacity-90"></div>
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNCI+PHBhdGggZD0iTTM2IDM0djZoNnYtNmgtNnptNiA2djZoNnYtNmgtNnptLTEyIDBoNnY2aC02di02em0xMiAwaDZ2NmgtNnYtNnoiLz48cGF0aCBkPSJNMTIgMTJoNnY2aC02di02em02IDZoNnY2aC02di02em0wLTZoNnY2aC02di02em0xMiAwaDZ2NmgtNnYtNnptLTEyIDEyaDZ2NmgtNnYtNnptMTIgMGg2djZoLTZ2LTZ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-50"></div>
                <div className="relative container mx-auto px-4 h-full flex items-center">
                    <div>
                        <div className="inline-block bg-white/20 text-white px-4 py-1 rounded-md text-sm font-medium mb-4 backdrop-blur-sm">
                            GET IN TOUCH
                        </div>
                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Contact Us</h1>
                        <p className="text-gray-100 max-w-xl text-lg">
                            Have a legal question or need representation? Our team is here to help.
                        </p>
                    </div>
                </div>
            </div>

            {/* Contact Content */}
            <div className="container mx-auto px-4 py-20">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                    {/* Contact Information */}
                    <div className="lg:col-span-1">
                        <div className="bg-gray-50 rounded-xl p-8 h-full">
                            <h3 className="text-xl font-bold mb-6 text-gray-800">Contact Information</h3>
                            
                            <div className="space-y-6">
                                <div className="flex">
                                    <div className="bg-indigo-100 text-indigo-600 p-3 rounded-lg mr-4 self-start">
                                        <MapPin className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Our Location</h4>
                                        <p className="text-gray-600 mt-1">Office No 330, Sher Shah Suri Block, 2nd Floor, Dist Courts Rawalpindi</p>
                                    </div>
                                </div>
                                
                                <div className="flex">
                                    <div className="bg-indigo-100 text-indigo-600 p-3 rounded-lg mr-4 self-start">
                                        <Phone className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Phone Number</h4>
                                        <p className="text-gray-600 mt-1">+92 332 9754400</p>
                                        <button 
                                            onClick={handleWhatsappContact}
                                            className="text-indigo-600 font-medium inline-block mt-1 hover:text-indigo-800 transition-colors"
                                        >
                                            Contact via WhatsApp
                                        </button>
                                    </div>
                                </div>
                                
                                <div className="flex">
                                    <div className="bg-indigo-100 text-indigo-600 p-3 rounded-lg mr-4 self-start">
                                        <Mail className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Email Address</h4>
                                        <p className="text-gray-600 mt-1">chkhurram379@gmail.com</p>
                                        <a 
                                            href="mailto:chkhurram379@gmail.com"
                                            className="text-indigo-600 font-medium inline-block mt-1 hover:text-indigo-800 transition-colors"
                                        >
                                            Send Email
                                        </a>
                                    </div>
                                </div>

                                <div className="flex">
                                    <div className="bg-indigo-100 text-indigo-600 p-3 rounded-lg mr-4 self-start">
                                        <Clock className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Working Hours</h4>
                                        <p className="text-gray-600 mt-1">Monday - Friday: 9:00 AM - 6:00 PM</p>
                                        <p className="text-gray-600">Saturday: 9:00 AM - 1:00 PM</p>
                                        <p className="text-gray-600">Sunday: Closed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-xl shadow-md p-8 border border-gray-100">
                            <h3 className="text-xl font-bold mb-6 text-gray-800">Get Free Consultation</h3>
                            
                            {isSubmitted ? (
                                <div className="flex flex-col items-center justify-center text-center p-8">
                                    <div className="bg-green-100 text-green-600 p-3 rounded-full mb-4">
                                        <CheckCircle className="w-8 h-8" />
                                    </div>
                                    <h4 className="text-xl font-bold text-gray-800 mb-2">Message Sent Successfully!</h4>
                                    <p className="text-gray-600">
                                        Thank you for contacting us. One of our legal experts will get back to you shortly.
                                    </p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                                                placeholder="Your name"
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                                                placeholder="Your email"
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                                            <input
                                                type="tel"
                                                id="phone"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                                                placeholder="Your phone"
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                                            <select
                                                id="subject"
                                                name="subject"
                                                value={formData.subject}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                                                required
                                            >
                                                <option value="">Select a subject</option>
                                                <option value="Criminal Law">Criminal Law</option>
                                                <option value="Family Law">Family Law</option>
                                                <option value="Civil Law">Civil Law</option>
                                                <option value="Business Law">Business Law</option>
                                                <option value="International Law">International Law</option>
                                                <option value="Labor Law">Labor Law</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="mb-6">
                                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Your Message</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            rows="5"
                                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                                            placeholder="Describe your legal issue or inquiry"
                                            required
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 rounded-lg font-medium flex items-center justify-center transition-colors ${
                                            isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                                        }`}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Sending...
                                            </>
                                        ) : (
                                            <>
                                                Send Message <Send className="ml-2 w-5 h-5" />
                                            </>
                                        )}
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;